<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

const { isMobile } = useDevice()

const cityStore = useCityStore()

const cityName = computed(() => {
  return cityStore.cityInfo?.padeg?.pred || 'вашем городе'
})
</script>

<template>
  <nuxt-link :prefetch="false" class="banner" to="/delivery/">
    <div class="banner__image">
      <nuxt-img
        src="/main-banner-car.webp"
        alt="Картинка машины"
        class="banner__image-item"
      />
    </div>

    <h1 class="banner__headline">Доставка суши в {{ cityName }}</h1>

    <div class="banner__footer">
      <time class="banner__time">~60 минут</time>

      <div class="banner__link">
        Рассчитать для меня

        <the-icon
          name="expand-right"
          :size="isMobile ? 12 : 16"
          color="var(--ui-primary)"
        />
      </div>
    </div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.banner {
  display: grid;
  gap: 0 10px;
  width: 100%;
  padding: 16px;
  font-size: 12px;
  font-weight: 800;
  color: var(--ui-text-primary);
  background: var(--ui-grey);
  border-radius: 20px;

  @include media('>=tablet') {
    gap: 0 20px;
    max-width: 500px;
    font-size: 16px;
  }

  &__image {
    display: flex;
    grid-area: 1 / 1 / 3 / 2;
    align-items: center;
    justify-content: center;

    &-item {
      width: 65px;
      height: 36px;
    }
  }

  &__headline {
    grid-area: 1 / 2 / 2 / 4;
    font-size: 12px;
    font-weight: 800;

    @include media('>=tablet') {
      font-size: 16px;
    }
  }

  &__footer {
    display: flex;
    grid-area: 2 / 2 / 3 / 4;
  }

  &__time {
    margin-right: 16px;

    @include media('<=portrait-phone') {
      margin-right: 8px;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    color: var(--ui-primary);

    @include media('>=tablet') {
      font-size: 14px;
    }
  }
}
</style>
